module.exports = __webpack_public_path__ + "static/saas-solution-de5cd19c2d13ac4d8ec74858c87e1d5b.png";